import { defineCopy } from '@/i18n'

// Text for the mock Homekind screens inside PhoneMockup. Names (Rina, Bi Inah, Pak Joko) stay the same in
// both languages; amounts and dates follow each language's conventions.
export default defineCopy('appScreen', {
  id: {
    common: {
      household: 'Keluarga Santoso',
      month: 'Oktober 2026',
      plnHome: 'PLN Rumah Tangerang',
      acService: 'Servis AC kamar utama',
      familyArisan: 'Arisan keluarga besar',
      going: 'Hadir',
      maybe: 'Mungkin',
      notGoing: 'Tidak',
      total: 'Rp489.000',
    },
    nav: { home: 'Beranda', budget: 'Kas', agenda: 'Agenda', chat: 'Chat', more: 'Lainnya' },
    home: {
      greeting: 'Selamat pagi, Rina',
      spendLabel: 'Pengeluaran Oktober',
      spendAmount: 'Rp6.420.000',
      budgetOf: '71% dari anggaran Rp9.000.000',
      daysLeft: '19 hari lagi',
      quick: { log: 'Catat', bills: 'Tagihan', shopping: 'Belanja', upkeep: 'Rawat' },
      today: 'Hari ini',
      todayDate: 'Sen, 12 Okt',
      schoolRun: 'Antar sekolah Kirana',
      dad: 'Ayah',
      trash: 'Buang sampah',
      trashSub: 'Tugas · Bi Inah',
      piano: 'Les piano',
      pianoSub: '2 hadir · 1 mungkin',
      attention: 'Perlu perhatian',
      plnSub: 'Rp489.000 · jatuh tempo 20 Okt',
      pay: 'Bayar',
      acSub: '3 hari lagi · Pak Joko',
    },
    budget: {
      title: 'Kas & Anggaran',
      shared: 'Bersama',
      private: 'Pribadi',
      income: 'Pemasukan',
      incomeAmount: 'Rp15,0 jt',
      spending: 'Pengeluaran',
      spendingAmount: 'Rp6,42 jt',
      categories: 'Anggaran kategori',
      of: 'dari',
      // Same order as the percentages in AppScreen.vue
      budgets: [
        { name: 'Belanja Dapur', spent: 'Rp2,15 jt', limit: 'Rp2,5 jt' },
        { name: 'Pendidikan', spent: 'Rp1,8 jt', limit: 'Rp1,8 jt' },
        { name: 'Listrik & Air', spent: 'Rp579 rb', limit: 'Rp900 rb' },
      ],
      recent: 'Transaksi terbaru',
      weekly: 'Belanja mingguan',
      weeklySub: 'Rina · Belanja Dapur',
      weeklyAmount: '-412.500',
      ac: 'Servis AC',
      auto: 'otomatis',
      acSub: 'dari Perawatan',
      acAmount: '-250.000',
    },
    bills: {
      eyebrow: 'Tagihan',
      title: 'PLN Pascabayar',
      label: 'Rumah Tangerang',
      name: 'Nama',
      period: 'Periode',
      periodValue: 'Okt 2026',
      usage: 'Pemakaian',
      due: 'Jatuh tempo',
      dueValue: '20 Okt',
      bill: 'Tagihan',
      billAmount: 'Rp486.500',
      adminFee: 'Biaya admin',
      adminAmount: 'Rp2.500',
      total: 'Total',
      payWith: 'Bayar dengan',
      usageChart: 'Pemakaian 6 bulan',
      // Same order as the usage values in AppScreen.vue
      months: ['Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt'],
      payCta: 'Bayar Rp489.000',
    },
    agenda: {
      title: 'Agenda Keluarga',
      // Monday first, matching the week in AppScreen.vue
      weekdays: ['Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab', 'Min'],
      schoolRun: 'Antar sekolah',
      schoolRunSub: 'Ayah · berulang Sen–Jum',
      trash: 'Buang sampah',
      trashSub: 'Bi Inah · Sel & Jum',
      piano: 'Les piano Kirana',
      pianoGoing: '2 hadir',
      grandma: 'Rumah Eyang',
      dueDate: '20 Okt',
      plnDue: 'Jatuh tempo PLN',
      fromBills: 'dari Tagihan',
    },
    shopping: {
      eyebrow: 'Daftar',
      title: 'Belanja Mingguan',
      live: { pre: 'Bi Inah mencentang ', strong: 'Telur', post: ' · baru saja' },
      // Same order as the done/by flags in AppScreen.vue
      items: [
        { name: 'Beras', qty: '5 kg' },
        { name: 'Telur', qty: '1 kg' },
        { name: 'Minyak goreng', qty: '2 L' },
        { name: 'Susu UHT', qty: '6 kotak' },
        { name: 'Bayam', qty: '2 ikat' },
        { name: 'Sabun cuci piring', qty: '1 botol' },
      ],
      estimate: 'Perkiraan total',
      estimateAmount: 'Rp418.000',
      done: 'Selesai belanja · catat ke Kas',
    },
    maintenance: {
      title: 'Perawatan Rumah',
      subtitle: 'Kesehatan rumah',
      overdue: 'Terlambat',
      thisMonth: 'Bulan ini',
      scheduled: 'Terjadwal',
      carTax: 'Pajak STNK Avanza',
      carTaxSub: 'Terlambat 2 hari',
      acSub: '15 Okt · tiap 3 bulan',
      tank: 'Kuras toren air',
      tankSub: '25 Okt · tiap 6 bulan',
      propertyTax: 'PBB 2026',
      propertyTaxSub: 'Lunas · 4 Agu',
      handymen: 'Buku tukang',
      vendor: 'Pak Joko Service AC',
      vendorSub: '4,8 · 6 pekerjaan',
    },
    chat: {
      members: '5 anggota · 3 online',
      billOut: 'Tagihan listrik bulan ini sudah keluar ya',
      billHead: 'Tagihan',
      due: 'Jatuh tempo 20 Okt',
      paidBy: 'Lunas oleh Rina',
      paidReply: 'Sudah Bunda bayar barusan 👍',
      eventHead: 'Acara',
      eventWhen: 'Sab, 17 Okt · 19:30',
      joining: 'Aku ikut! 🎉',
      composer: 'Tulis pesan…',
    },
  },
  en: {
    common: {
      household: 'The Santoso Family',
      month: 'October 2026',
      plnHome: 'PLN · Tangerang House',
      acService: 'Master bedroom AC service',
      familyArisan: 'Extended family gathering',
      going: 'Going',
      maybe: 'Maybe',
      notGoing: 'No',
      total: 'Rp489,000',
    },
    nav: { home: 'Home', budget: 'Budget', agenda: 'Agenda', chat: 'Chat', more: 'More' },
    home: {
      greeting: 'Good morning, Rina',
      spendLabel: 'October spending',
      spendAmount: 'Rp6,420,000',
      budgetOf: '71% of the Rp9,000,000 budget',
      daysLeft: '19 days left',
      quick: { log: 'Log', bills: 'Bills', shopping: 'Shop', upkeep: 'Upkeep' },
      today: 'Today',
      todayDate: 'Mon, Oct 12',
      schoolRun: 'School run for Kirana',
      dad: 'Dad',
      trash: 'Take out the trash',
      trashSub: 'Chore · Bi Inah',
      piano: 'Piano lesson',
      pianoSub: '2 going · 1 maybe',
      attention: 'Needs attention',
      plnSub: 'Rp489,000 · due Oct 20',
      pay: 'Pay',
      acSub: 'In 3 days · Pak Joko',
    },
    budget: {
      title: 'Money & Budget',
      shared: 'Shared',
      private: 'Private',
      income: 'Income',
      incomeAmount: 'Rp15.0M',
      spending: 'Spending',
      spendingAmount: 'Rp6.42M',
      categories: 'Category budgets',
      of: 'of',
      budgets: [
        { name: 'Groceries', spent: 'Rp2.15M', limit: 'Rp2.5M' },
        { name: 'Education', spent: 'Rp1.8M', limit: 'Rp1.8M' },
        { name: 'Power & Water', spent: 'Rp579k', limit: 'Rp900k' },
      ],
      recent: 'Recent transactions',
      weekly: 'Weekly shopping',
      weeklySub: 'Rina · Groceries',
      weeklyAmount: '-412,500',
      ac: 'AC service',
      auto: 'auto',
      acSub: 'from Maintenance',
      acAmount: '-250,000',
    },
    bills: {
      eyebrow: 'Bills',
      title: 'PLN Postpaid',
      label: 'Tangerang House',
      name: 'Name',
      period: 'Period',
      periodValue: 'Oct 2026',
      usage: 'Usage',
      due: 'Due',
      dueValue: 'Oct 20',
      bill: 'Bill',
      billAmount: 'Rp486,500',
      adminFee: 'Admin fee',
      adminAmount: 'Rp2,500',
      total: 'Total',
      payWith: 'Pay with',
      usageChart: '6-month usage',
      months: ['May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'],
      payCta: 'Pay Rp489,000',
    },
    agenda: {
      title: 'Family Agenda',
      weekdays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      schoolRun: 'School run',
      schoolRunSub: 'Dad · repeats Mon–Fri',
      trash: 'Take out the trash',
      trashSub: 'Bi Inah · Tue & Fri',
      piano: "Kirana's piano lesson",
      pianoGoing: '2 going',
      grandma: "Grandma's house",
      dueDate: 'Oct 20',
      plnDue: 'PLN bill due',
      fromBills: 'from Bills',
    },
    shopping: {
      eyebrow: 'List',
      title: 'Weekly Shopping',
      live: { pre: 'Bi Inah checked off ', strong: 'Eggs', post: ' · just now' },
      items: [
        { name: 'Rice', qty: '5 kg' },
        { name: 'Eggs', qty: '1 kg' },
        { name: 'Cooking oil', qty: '2 L' },
        { name: 'UHT milk', qty: '6 cartons' },
        { name: 'Spinach', qty: '2 bunches' },
        { name: 'Dish soap', qty: '1 bottle' },
      ],
      estimate: 'Estimated total',
      estimateAmount: 'Rp418,000',
      done: 'Done shopping · log to Budget',
    },
    maintenance: {
      title: 'Home Maintenance',
      subtitle: 'Home health',
      overdue: 'Overdue',
      thisMonth: 'This month',
      scheduled: 'Scheduled',
      carTax: 'Avanza vehicle tax',
      carTaxSub: '2 days overdue',
      acSub: 'Oct 15 · every 3 months',
      tank: 'Drain the water tank',
      tankSub: 'Oct 25 · every 6 months',
      propertyTax: 'Property tax 2026',
      propertyTaxSub: 'Paid · Aug 4',
      handymen: 'Handyman book',
      vendor: 'Pak Joko AC Service',
      vendorSub: '4.8 · 6 jobs',
    },
    chat: {
      members: '5 members · 3 online',
      billOut: "This month's electricity bill is out",
      billHead: 'Bill',
      due: 'Due Oct 20',
      paidBy: 'Paid by Rina',
      paidReply: 'Mom just paid it 👍',
      eventHead: 'Event',
      eventWhen: 'Sat, Oct 17 · 19:30',
      joining: "I'm in! 🎉",
      composer: 'Write a message…',
    },
  },
})
